module.exports = __webpack_public_path__ + "static/options-5a2bc29ae88cac6a058bc555caec40af.png";